/* ============================================================
 * devM-load-more.js  (GRANDIANI sandbox — GDEV load-more)
 * Powers Ella's native "Show more" button on collection pages.
 * Clicking [data-infinite-scrolling] fetches the next ?page=N,
 * appends its products to the grid, and updates the counter,
 * progress bar and the button's next-page target.
 * Also supports "infinite" mode (auto-load when button is visible).
 * Self-contained, vanilla JS, event-delegated so it survives the
 * theme's AJAX filter/sort re-renders.
 * ============================================================ */
(function () {
  'use strict';

  var GRID = '#main-collection-product-grid';
  var BTN = '[data-infinite-scrolling]';

  function setLoading(on) {
    document.body.classList.toggle('has-halo-loader', !!on);
  }

  function updatePagination(doc, btn) {
    var wrapper = btn.closest('.pagination-wrapper') || document;

    var newEnd = doc.querySelector('.pagination-page-total [data-total-end]');
    var curEnd = wrapper.querySelector('[data-total-end]');
    if (newEnd && curEnd) curEnd.textContent = newEnd.textContent;

    var newProg = doc.querySelector('.pagination-total-item');
    var curProg = wrapper.querySelector('.pagination-total-item');
    if (newProg && curProg) curProg.style.width = newProg.style.width || '100%';

    // The next button only carries data-infinite-scrolling when another
    // page exists. If the fetched page has none, we're on the last page.
    var newBtn = doc.querySelector(BTN);
    if (newBtn && newBtn.getAttribute('data-href')) {
      btn.setAttribute('data-href', newBtn.getAttribute('data-href'));
      btn.setAttribute('href', newBtn.getAttribute('href'));
    } else {
      btn.classList.add('disabled');
      btn.removeAttribute('data-href');
      btn.setAttribute('href', 'javascript:void(0)');
      var fetchedAnchor = doc.querySelector('.pagination-page-infinite a');
      if (fetchedAnchor) btn.textContent = fetchedAnchor.textContent.trim();
    }
  }

  function fetchNext(btn) {
    if (!btn || btn.classList.contains('disabled') || btn.dataset.loading === '1') return;
    var url = btn.getAttribute('data-href');
    if (!url) return;

    btn.dataset.loading = '1';
    btn.classList.add('is-loading');
    setLoading(true);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID);
        var curGrid = document.querySelector(GRID);
        if (newGrid && curGrid) {
          var items = newGrid.querySelectorAll(':scope > li');
          for (var i = 0; i < items.length; i++) {
            // Skip the repeated in-grid promo tiles on subsequent pages.
            if (items[i].classList.contains('devBnrInsideProducts')) continue;
            curGrid.appendChild(document.importNode(items[i], true));
          }
        }
        updatePagination(doc, btn);
        // Nudge the theme's lazy-image loaders for the new cards.
        window.dispatchEvent(new Event('scroll'));
        window.sharedFunctions && window.sharedFunctions.swapHoverVideoProductCard &&
          window.sharedFunctions.swapHoverVideoProductCard();
      })
      .catch(function (e) { if (window.console) console.warn('load-more failed', e); })
      .then(function () {
        btn.dataset.loading = '0';
        btn.classList.remove('is-loading');
        setLoading(false);
      });
  }

  // Click delegation — works even after AJAX filter/sort re-renders the grid.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(BTN) : null;
    if (!btn) return;
    e.preventDefault();
    fetchNext(btn);
  });

  // "infinite" mode: auto-load when the button scrolls into view.
  function initInfinite() {
    if (!('IntersectionObserver' in window)) return;
    var nav = document.querySelector('.pagination-infinite');
    if (!nav) return;
    var btn = nav.querySelector(BTN);
    if (!btn) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var b = document.querySelector('.pagination-infinite ' + BTN);
          if (b && !b.classList.contains('disabled')) fetchNext(b);
        }
      }
    }, { rootMargin: '300px' });
    io.observe(btn);
  }

  if (document.readyState !== 'loading') initInfinite();
  else document.addEventListener('DOMContentLoaded', initInfinite);
})();
